import { mutationOptions } from '@tanstack/react-query'

import { QueryKeys } from '@/configs/query'
import type { ApiError } from '@/lib/api/api-error'
import { siteApi } from '@/lib/api/site-client'

export type SubscribeNewsletterPayload = { email: string }
export type SubscribeNewsletterResponse = unknown

export const subscribeNewsletterMutation = () =>
  mutationOptions<SubscribeNewsletterResponse, ApiError, SubscribeNewsletterPayload>({
    mutationKey: [...QueryKeys.NEWSLETTER, 'subscribe'],
    mutationFn: async (payload) => {
      const data = await siteApi.post<unknown>({
        url: '/api/newsletter-subscriptions',
        data: { data: { email: payload.email } },
      })
      return data
    },
  })
